const flagPaths = {
  gb: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#012169"/>
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8"/>
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="4"/>
      <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="13"/>
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="7"/>
    </svg>
  ),
  fr: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="20" height="40" fill="#002395"/>
      <rect x="20" width="20" height="40" fill="#fff"/>
      <rect x="40" width="20" height="40" fill="#ED2939"/>
    </svg>
  ),
  es: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#AA151B"/>
      <rect y="10" width="60" height="20" fill="#F1BF00"/>
    </svg>
  ),
  de: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="13.3" fill="#000"/>
      <rect y="13.3" width="60" height="13.4" fill="#DD0000"/>
      <rect y="26.7" width="60" height="13.3" fill="#FFCC00"/>
    </svg>
  ),
  it: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="20" height="40" fill="#009246"/>
      <rect x="20" width="20" height="40" fill="#fff"/>
      <rect x="40" width="20" height="40" fill="#CE2B37"/>
    </svg>
  ),
  pt: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="24" height="40" fill="#006600"/>
      <rect x="24" width="36" height="40" fill="#FF0000"/>
      <circle cx="24" cy="20" r="7" fill="#FFCC00"/>
    </svg>
  ),
  nl: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="13.3" fill="#AE1C28"/>
      <rect y="13.3" width="60" height="13.4" fill="#fff"/>
      <rect y="26.7" width="60" height="13.3" fill="#21468B"/>
    </svg>
  ),
  pl: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="20" fill="#fff"/>
      <rect y="20" width="60" height="20" fill="#DC143C"/>
    </svg>
  ),
  tr: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#E30A17"/>
      <circle cx="22" cy="20" r="10" fill="#fff"/>
      <circle cx="25" cy="20" r="8" fill="#E30A17"/>
      <polygon points="33,20 29.5,21.5 31,25 28,22.5 25,25 26.5,21.5 23,20 26.5,18.5 25,15 28,17.5 31,15 29.5,18.5" fill="#fff"/>
    </svg>
  ),
  ru: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="13.3" fill="#fff"/>
      <rect y="13.3" width="60" height="13.4" fill="#0039A6"/>
      <rect y="26.7" width="60" height="13.3" fill="#D52B1E"/>
    </svg>
  ),
  jp: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#fff"/>
      <circle cx="30" cy="20" r="11" fill="#BC002D"/>
    </svg>
  ),
  cn: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#DE2910"/>
      <polygon points="10,6 11.8,11.5 17.5,11.5 12.9,14.8 14.6,20.3 10,17 5.4,20.3 7.1,14.8 2.5,11.5 8.2,11.5" fill="#FFDE00"/>
      <polygon points="20,3 20.6,5 22.5,5 21,6.2 21.5,8 20,7 18.5,8 19,6.2 17.5,5 19.4,5" fill="#FFDE00"/>
      <polygon points="23,7 23.6,9 25.5,9 24,10.2 24.5,12 23,11 21.5,12 22,10.2 20.5,9 22.4,9" fill="#FFDE00"/>
      <polygon points="23,13 23.6,15 25.5,15 24,16.2 24.5,18 23,17 21.5,18 22,16.2 20.5,15 22.4,15" fill="#FFDE00"/>
      <polygon points="20,17 20.6,19 22.5,19 21,20.2 21.5,22 20,21 18.5,22 19,20.2 17.5,19 19.4,19" fill="#FFDE00"/>
    </svg>
  ),
  sa: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#006C35"/>
      <rect x="10" y="14" width="40" height="3" rx="1" fill="#fff"/>
      <rect x="28" y="10" width="4" height="18" rx="1" fill="#fff"/>
    </svg>
  ),
  us: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#B22234"/>
      <rect y="3.1" width="60" height="3.1" fill="#fff"/>
      <rect y="9.2" width="60" height="3.1" fill="#fff"/>
      <rect y="15.4" width="60" height="3.1" fill="#fff"/>
      <rect y="21.5" width="60" height="3.1" fill="#fff"/>
      <rect y="27.7" width="60" height="3.1" fill="#fff"/>
      <rect y="33.8" width="60" height="3.1" fill="#fff"/>
      <rect width="24" height="21.5" fill="#3C3B6E"/>
    </svg>
  ),
  br: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#009B3A"/>
      <polygon points="30,4 56,20 30,36 4,20" fill="#FEDF00"/>
      <circle cx="30" cy="20" r="8" fill="#002776"/>
    </svg>
  ),
  in: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="13.3" fill="#FF9933"/>
      <rect y="13.3" width="60" height="13.4" fill="#fff"/>
      <rect y="26.7" width="60" height="13.3" fill="#138808"/>
      <circle cx="30" cy="20" r="4" fill="none" stroke="#000080" strokeWidth="0.8"/>
    </svg>
  ),
  kr: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#fff"/>
      <circle cx="30" cy="20" r="10" fill="#CD2E3A"/>
      <path d="M30,10 A10,10 0 0,1 30,30 A5,5 0 0,0 30,20 A5,5 0 0,1 30,10" fill="#0047A0"/>
    </svg>
  ),
  ca: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="15" height="40" fill="#FF0000"/>
      <rect x="15" width="30" height="40" fill="#fff"/>
      <rect x="45" width="15" height="40" fill="#FF0000"/>
      <path d="M30,8 L31,14 L34,11 L32,16 L37,15 L33,18 L37,21 L32,20 L34,25 L31,22 L30,28 L29,22 L26,25 L28,20 L23,21 L27,18 L23,15 L28,16 L26,11 L29,14Z" fill="#FF0000"/>
    </svg>
  ),
  au: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#00008B"/>
      <rect width="30" height="20" fill="#012169"/>
      <path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" strokeWidth="4"/>
      <path d="M0,0 L30,20 M30,0 L0,20" stroke="#C8102E" strokeWidth="2"/>
      <path d="M15,0 V20 M0,10 H30" stroke="#fff" strokeWidth="6"/>
      <path d="M15,0 V20 M0,10 H30" stroke="#C8102E" strokeWidth="3"/>
    </svg>
  ),
  ch: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#FF0000"/>
      <rect x="25" y="10" width="10" height="20" fill="#fff"/>
      <rect x="20" y="15" width="20" height="10" fill="#fff"/>
    </svg>
  ),
  se: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="40" fill="#006AA7"/>
      <rect x="16" width="8" height="40" fill="#FECC00"/>
      <rect y="16" width="60" height="8" fill="#FECC00"/>
    </svg>
  ),
  be: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="20" height="40" fill="#000"/>
      <rect x="20" width="20" height="40" fill="#FFD100"/>
      <rect x="40" width="20" height="40" fill="#FF0F21"/>
    </svg>
  ),
  at: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="13.3" fill="#ED2939"/>
      <rect y="13.3" width="60" height="13.4" fill="#fff"/>
      <rect y="26.7" width="60" height="13.3" fill="#ED2939"/>
    </svg>
  ),
  mx: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="20" height="40" fill="#006847"/>
      <rect x="20" width="20" height="40" fill="#fff"/>
      <rect x="40" width="20" height="40" fill="#CE1126"/>
    </svg>
  ),
  ua: (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <rect width="60" height="20" fill="#005BBB"/>
      <rect y="20" width="60" height="20" fill="#FFD500"/>
    </svg>
  ),
};

const langToCountry = {
  en: 'gb', fr: 'fr', es: 'es', de: 'de', it: 'it', pt: 'pt',
  nl: 'nl', pl: 'pl', tr: 'tr', ru: 'ru', ja: 'jp', zh: 'cn', ar: 'sa', hi: 'in',
};

export const FlagIcon = ({ code, lang, size = 16 }) => {
  const countryCode = lang ? langToCountry[lang] : code?.toLowerCase();
  const flag = flagPaths[countryCode];
  if (!flag) return <span className="inline-block rounded-sm bg-muted" style={{ width: size * 1.4, height: size }} />;
  return (
    <span
      className="inline-block rounded-sm overflow-hidden shrink-0"
      style={{ width: size * 1.4, height: size }}
      data-testid={`flag-${countryCode}`}
    >
      {flag}
    </span>
  );
};

export const countryNames = {
  AF:'Afghanistan',AL:'Albanie',DZ:'Algérie',AD:'Andorre',AO:'Angola',AR:'Argentine',AM:'Arménie',AU:'Australie',AT:'Autriche',AZ:'Azerbaïdjan',
  BS:'Bahamas',BH:'Bahreïn',BD:'Bangladesh',BB:'Barbade',BY:'Biélorussie',BE:'Belgique',BZ:'Belize',BJ:'Bénin',BT:'Bhoutan',BO:'Bolivie',
  BA:'Bosnie',BR:'Brésil',BN:'Brunei',BG:'Bulgarie',BF:'Burkina Faso',BI:'Burundi',KH:'Cambodge',CM:'Cameroun',CA:'Canada',CV:'Cap-Vert',
  CF:'Centrafrique',TD:'Tchad',CL:'Chili',CN:'Chine',CO:'Colombie',KM:'Comores',CG:'Congo',CR:'Costa Rica',HR:'Croatie',CU:'Cuba',
  CY:'Chypre',CZ:'Tchéquie',DK:'Danemark',DJ:'Djibouti',DM:'Dominique',DO:'Rép. Dominicaine',EC:'Équateur',EG:'Égypte',SV:'Salvador',
  GQ:'Guinée Éq.',ER:'Érythrée',EE:'Estonie',ET:'Éthiopie',FJ:'Fidji',FI:'Finlande',FR:'France',GA:'Gabon',GM:'Gambie',GE:'Géorgie',
  DE:'Allemagne',GH:'Ghana',GR:'Grèce',GT:'Guatemala',GN:'Guinée',GY:'Guyana',HT:'Haïti',HN:'Honduras',HK:'Hong Kong',HU:'Hongrie',
  IS:'Islande',IN:'Inde',ID:'Indonésie',IR:'Iran',IQ:'Irak',IE:'Irlande',IL:'Israël',IT:'Italie',JM:'Jamaïque',JP:'Japon',
  JO:'Jordanie',KZ:'Kazakhstan',KE:'Kenya',KW:'Koweït',KG:'Kirghizistan',LA:'Laos',LV:'Lettonie',LB:'Liban',LR:'Libéria',LY:'Libye',
  LI:'Liechtenstein',LT:'Lituanie',LU:'Luxembourg',MO:'Macao',MK:'Macédoine',MG:'Madagascar',MW:'Malawi',MY:'Malaisie',MV:'Maldives',ML:'Mali',
  MT:'Malte',MR:'Mauritanie',MU:'Maurice',MX:'Mexique',MD:'Moldavie',MC:'Monaco',MN:'Mongolie',ME:'Monténégro',MA:'Maroc',MZ:'Mozambique',
  MM:'Myanmar',NA:'Namibie',NP:'Népal',NL:'Pays-Bas',NZ:'Nouvelle-Zélande',NI:'Nicaragua',NE:'Niger',NG:'Nigéria',NO:'Norvège',OM:'Oman',
  PK:'Pakistan',PA:'Panama',PY:'Paraguay',PE:'Pérou',PH:'Philippines',PL:'Pologne',PT:'Portugal',QA:'Qatar',RO:'Roumanie',RU:'Russie',
  RW:'Rwanda',SA:'Arabie Saoudite',SN:'Sénégal',RS:'Serbie',SG:'Singapour',SK:'Slovaquie',SI:'Slovénie',ZA:'Afrique du Sud',KR:'Corée du Sud',
  ES:'Espagne',LK:'Sri Lanka',SD:'Soudan',SE:'Suède',CH:'Suisse',SY:'Syrie',TW:'Taïwan',TJ:'Tadjikistan',TZ:'Tanzanie',TH:'Thaïlande',
  TN:'Tunisie',TR:'Turquie',TM:'Turkménistan',UG:'Ouganda',UA:'Ukraine',AE:'Émirats Arabes Unis',GB:'Royaume-Uni',US:'États-Unis',
  UY:'Uruguay',UZ:'Ouzbékistan',VE:'Venezuela',VN:'Vietnam',YE:'Yémen',ZM:'Zambie',ZW:'Zimbabwe',XX:'Inconnu',
};
